import {
  SET_MAPPER_MODELS,
  SET_MAPPER_DATA,
  SET_MAPPER_MODEL_ID,
  SUCCESS_MAPPER_BASIC_MAPPER,
  SET_ERROR_MAPPER,
  SET_MAPPER_TEMPLATES,
  SET_MAPPER_TEMPLATE,
  SET_TEMPLATE_ERROR,
  SET_MAPPER_VALIDATION,
  SHOW_VALIDATION_PROCESS,
  HIDE_VALIDATION_PROCESS,
  SET_MAPPER_VALIDATION_SUCCESS,
  SHOW_LOAD_BASIC_MAPPER,
  SET_MAPPER_FILES_LOADER,
  SET_MAPPER_FILES,
} from "./actionTypes";

const INITIAL_STATE = {
  data: null,
  models: [],
  model: [],
  templates: [],
  template: {},
  validationErrors: [],
  validationSuccess: false,
  validationProcess: false,
  success: false,
  addMappProcess: false,
  mapperFilesData: {
    count: 0,
    next: null,
    previous: null,
    page: 1,
    sizePerPage: 10,
    results: [],
  },
  mapperFilesLoader: false,
  error: false,
  templateError: false,
};

const Mapper = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case SHOW_LOAD_BASIC_MAPPER:
      return {
        ...state,
        addMappProcess: action.payload,
      };
    case SET_MAPPER_VALIDATION:
      return {
        ...state,
        validationErrors: action.payload,
      };
    case SET_MAPPER_VALIDATION_SUCCESS:
      return {
        ...state,
        validationSuccess: action.payload,
      };
    case SHOW_VALIDATION_PROCESS:
      return {
        ...state,
        validationProcess: true,
      };
    case HIDE_VALIDATION_PROCESS:
      return {
        ...state,
        validationProcess: false,
      };
    case SET_MAPPER_TEMPLATES:
      return {
        ...state,
        templates: action.payload,
      };
    case SET_MAPPER_TEMPLATE:
      return {
        ...state,
        template: action.payload,
      };
    case SET_TEMPLATE_ERROR:
      return {
        ...state,
        templateError: action.payload,
      };
    case SET_MAPPER_DATA:
      return {
        ...state,
        data: action.payload,
      };
    case SET_MAPPER_MODELS:
      return {
        ...state,
        models: action.payload,
      };
    case SET_MAPPER_MODEL_ID:
      return {
        ...state,
        model: action.payload,
      };
    case SUCCESS_MAPPER_BASIC_MAPPER:
      return {
        ...state,
        success: action.payload,
      };
    case SET_ERROR_MAPPER:
      return {
        ...state,
        error: action.payload,
      };
    case SET_MAPPER_FILES:
      return {
        ...state,
        mapperFilesData: action.payload,
      };
    case SET_MAPPER_FILES_LOADER:
      return {
        ...state,
        mapperFilesLoader: !state.mapperFilesLoader,
      };
    default:
      return state;
  }
};

export default Mapper;
